import React from "react";
import { Card, CardBody, Table } from "reactstrap";

const cardShell = {
  background: "var(--vz-secondary-bg, #fff)",
  border: "1px solid var(--vz-border-color)",
  borderRadius: 10,
  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  overflow: "hidden",
};

const RelatedAlertsTable = () => {
  const alerts = [
    {
      id: "A-2024-001",
      timestamp: "10/30/24 15:29:50",
      description: "High CPU utilization on Payment Service DB instance.",
      source: "Prometheus",
      severity: "Medium",
      severityColor: "warning",
    },
    {
      id: "A-2024-002",
      timestamp: "10/30/24 15:30:05",
      description: "Increased error rates on /api/payment endpoint.",
      source: "Sentry",
      severity: "Major",
      severityColor: "danger",
    },
    {
      id: "A-2024-003",
      timestamp: "10/30/24 15:30:10",
      description: "Network congestion detected in primary payment region.",
      source: "CloudWatch",
      severity: "Low",
      severityColor: "secondary",
    },
    {
      id: "A-2024-004",
      timestamp: "10/30/24 15:31:00",
      description: "Spike in active database connections on cluster-pay-01.",
      source: "New Relic",
      severity: "Critical",
      severityColor: "danger",
    },
    {
      id: "A-2024-005",
      timestamp: "10/30/24 15:32:15",
      description: "Increased queue depth for payment processing jobs.",
      source: "RabbitMQ Monitor",
      severity: "Medium",
      severityColor: "warning",
    },
  ];

  return (
    <Card className="shadow-sm border mt-4" style={cardShell}>
      <CardBody>
        <h5 className="fw-bold mb-4">Related Alerts & Events</h5>

        <div className="table-responsive">
          <Table className="table-striped table-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th scope="col">ID</th>
                <th scope="col">Timestamp</th>
                <th scope="col">Description</th>
                <th scope="col">Source</th>
                <th scope="col">Severity</th>
              </tr>
            </thead>
            <tbody>
              {alerts.map((alert, index) => (
                <tr key={index}>
                  <td className="fw-medium">{alert.id}</td>
                  <td>{alert.timestamp}</td>
                  <td>{alert.description}</td>
                  <td>{alert.source}</td>
                  <td>
                    <span className={`badge bg-${alert.severityColor}`}>
                      {alert.severity}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </CardBody>
    </Card>
  );
};

export default RelatedAlertsTable;
